import styled from 'styled-components';

export const Container = styled.div`
  width: 111px;
  margin-right: 15px;
  border-radius: 8px;
`;
